<template>
	<div>
		<v-subheader class="font-weight-bold pa-0">
			{{ $t("Customer") }}
		</v-subheader>
		{{ order.customer ? order.customer.name : null }}
		<a
			:href="`tel:` + order.customer_phone"
			target="_blank"
			v-if="order.customer_phone"
		>
			({{ order.customer_phone }})
		</a>
		<v-subheader class="font-weight-bold pa-0">
			{{ $t("label.items") }}
		</v-subheader>
		<v-simple-table class="elevation-1">
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">#</th>
						<th class="text-left">
							{{ $t("label.item") }}
						</th>
						<th class="text-center">
							{{ $t("label.quantity") }}
						</th>
						<th class="text-center">
							{{ $t("Price") }}
						</th>
						<th class="text-center">
							{{ $t("Subtotal") }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(line, index) in order.items"
						:key="index"
						:class="{
							'text-decoration-line-through text--disabled':
								!line.is_available,
						}"
					>
						<td>
							{{ index + 1 }}
						</td>
						<td>
							<a
								:href="
									$route('tenant.products.show', {
										tenant: $page.props.tenant.id,
										product: line.product_uuid,
									})
								"
								target="_blank"
							>
								{{ line.product_name }}
								<v-icon right small>mdi-open-in-new</v-icon>
							</a>
							<p v-if="line.note">
								<code class="red lighten-4 text-caption">
									{{ line.note }}
								</code>
							</p>
						</td>
						<td class="text-center">
							{{ line.available_quantity }}
							<small
								v-if="line.available_quantity < line.quantity"
								class="text-decoration-line-through"
							>
								({{ line.quantity }})
							</small>
						</td>
						<td class="text-center">
							{{ line.price | currency }}
						</td>
						<td class="text-center">
							{{ (line.quantity * line.price) | currency }}
						</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
		<template v-if="order.description">
			<v-subheader class="font-weight-bold pa-0">
				{{ $t("Description") }}
			</v-subheader>
			<strong>{{ order.description }}</strong>
		</template>
	</div>
</template>

<script>
export default {
	props: ["order"],
};
</script>